import React from 'react';
import { FerrisWheel as Ferris } from 'lucide-react';

function Footer() {
  return (
    <footer className="bg-gray-900">
      <div className="max-w-7xl mx-auto py-16 px-4 sm:px-6 lg:px-8 relative overflow-hidden">
        <div className="absolute inset-0 opacity-5">
          <div className="absolute inset-0">
            <div className="absolute inset-0 bg-[radial-gradient(circle_at_top_right,_var(--tw-gradient-stops))] from-pink-600 via-transparent to-transparent"></div>
            <div className="absolute inset-0 bg-[radial-gradient(circle_at_bottom_left,_var(--tw-gradient-stops))] from-blue-600 via-transparent to-transparent"></div>
          </div>
        </div>
        <div className="flex justify-center items-center mb-12 group">
          <div className="relative">
            <Ferris className="h-12 w-12 text-pink-500 transform animate-spin-slow hover:scale-110 transition-transform duration-700" />
            <div className="absolute inset-0 bg-gradient-to-r from-pink-400/30 to-purple-400/30 blur-2xl rounded-full animate-pulse"></div>
            <div className="absolute -inset-1 bg-gradient-to-r from-pink-500/20 to-purple-500/20 blur-xl rounded-full animate-spin-reverse-slow"></div>
          </div>
          <span className="ml-3 text-3xl font-black text-transparent bg-clip-text bg-gradient-to-r from-pink-500 via-pink-400 to-purple-400 group-hover:from-purple-400 group-hover:via-pink-400 group-hover:to-pink-500 transition-all duration-700 animate-gradient">
            ValentinaEventi
          </span>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-12">
          <div className="text-center">
            <h3 className="text-lg font-semibold text-white mb-4">Orari</h3>
            <p className="text-gray-400">Lun - Ven: 9:00 - 18:00</p>
            <p className="text-gray-400">Sab - Dom: 10:00 - 16:00</p>
          </div>
          <div className="text-center">
            <h3 className="text-lg font-semibold text-white mb-4">Servizi</h3>
            <p className="text-gray-400">Eventi privati e aziendali</p>
            <p className="text-gray-400">Feste e celebrazioni</p>
          </div>
          <div className="text-center">
            <h3 className="text-lg font-semibold text-white mb-4">Area Servita</h3>
            <p className="text-gray-400">Tutta Italia</p>
            <p className="text-gray-400">Servizio nazionale</p>
          </div>
        </div>
        <div className="mt-12 border-t border-gray-800 pt-8 text-center">
          <p className="text-base text-gray-400">
            © {new Date().getFullYear()} ValentinaEventi. Tutti i diritti riservati.
          </p>
          <div className="mt-4 flex justify-center space-x-6">
            <a href="#" className="text-gray-400 hover:text-pink-500 transition-colors duration-300">Privacy Policy</a>
            <a href="#" className="text-gray-400 hover:text-pink-500 transition-colors duration-300">Termini di Servizio</a>
            <a href="#" className="text-gray-400 hover:text-pink-500 transition-colors duration-300">Cookie Policy</a>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;